import { defineMessages } from 'react-intl';

export const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	fieldsToAddHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	nextButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandSection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseSection: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successPill: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type.card-title',
		defaultMessage: 'Update request type',
		description: 'Card title for the update request type action card',
	},
	fieldsToAddHeading: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type.fields-to-add-heading',
		defaultMessage: 'Fields to add:',
		description: 'Heading above the list of field names in the card body',
	},
	nextButton: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type.next-button',
		defaultMessage: 'Update',
		description: 'Primary button to confirm and continue the skill flow',
	},
	expandSection: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type.expand-section',
		defaultMessage: 'Show more',
		description: 'Accessible label for expanding the card body',
	},
	collapseSection: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type.collapse-section',
		defaultMessage: 'Show less',
		description: 'Accessible label for collapsing the card body',
	},
	expandBodyContent: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type.expand-body-content',
		defaultMessage: 'Show more',
		description:
			'Button label to expand the card content area when text exceeds the visible height',
	},
	collapseBodyContent: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type.collapse-body-content',
		defaultMessage: 'Show less',
		description:
			'Button label to collapse the card content area after it was expanded for long text',
	},
	successPill: {
		id: 'ai-mate.conversation-assistant-message-actions.update-request-type.success-pill',
		defaultMessage: `You've updated "{requestType}"`,
		description: 'Pill message shown after the update request type action succeeds',
	},
});
